<template>
    <div class="etm-tooltip-container" style="visibility:hidden;" v-if="!this.userMeta[this.userMetaHandle]">
        <div class="etm-tooltip-triangle"></div>
        <div class="etm-dismissible-tooltip">
            <div class="etm-close-tooltip" @click="dismiss" :title="editorStrings.dismiss_tooltip_title_attribute"></div>
            <div class="etm-tooltip-text">{{text}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props : [
            'text',
            'editorStrings',
            'userMetaHandle',
            'userMeta'
        ],
        methods : {
            dismiss : function(){
                let self = this
                document.dispatchEvent( new CustomEvent( 'etm_update_user_meta', {
                    'detail' : {
                        'userMetaKey' : self.userMetaHandle,
                        'userMetaValue' : true,
                    }
                } ) )
            }
        }
    }
</script>